import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from './Button'
import classnames from 'classnames'

const SHOW_MORE_INCREMENT = 100 // like show all

const CaseStudyMetaContents = class CaseStudyMetaContents extends Component {
  constructor () {
    super()
    this.state = {
      maxShowing: 9999 // for server side rendering
    }
  }
  componentWillReceiveProps (newtProps) {
    this.setState({ maxShowing: newtProps.defaultMaxShowing })
  }
  componentDidMount () {
    this.setState({ maxShowing: this.props.defaultMaxShowing })
  }
  render () {
    const { metaContents, extraClass } = this.props
    const { maxShowing } = this.state

    return (
      <div className={classnames('meta-contents', extraClass)}>
        <ul>
          {metaContents &&
            metaContents
              .slice(0, maxShowing)
              .map(({ label, content }, index) => {
                return (
                  <div className='h4 grey meta-contents__child' key={index}>
                    <div className='meta-contents__child__label mb1'>
                      {label}
                    </div>
                    <div
                      className='meta-contents__child__content'
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  </div>
                )
              })}
        </ul>
        {metaContents &&
          metaContents.length > maxShowing && (
            <Button
              className='button button--plain mb4'
              onClick={() => {
                this.setState({
                  maxShowing: this.state.maxShowing + SHOW_MORE_INCREMENT
                })
              }}
            >
              [...]
            </Button>
          )}
      </div>
    )
  }
}

CaseStudyMetaContents.propTypes = {
  metaContents: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      content: PropTypes.string
    }).isRequired
  ).isRequired
}

export default connect()(CaseStudyMetaContents)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/CaseStudyMetaContents.js